import { fetchData } from "src/async/fetch";
import { hostUrl } from "src/config/host";
import { ADD_ACTIVITY_DATA, GET_ACTIVITY_DATA, DELETE_ACTIVITY_DATA } from "./type";

export const getActivity =
  (body, signal = null) =>
  async (dispatch) => {
    try {
      const res = await fetchData("POST", `${hostUrl}/list-activity`, body, signal);
      const data = await res.json();

      if (data.status === 200) {
        dispatch({ type: GET_ACTIVITY_DATA, payload: data.data });
        return data.data;
      } else {
        throw new Error(data.message);
      }
    } catch (err) {
      throw new Error(err.message);
    }
  };

export const addActivity = (body) => async (dispatch) => {
  try {
    const res = await fetchData("POST", `${hostUrl}/add-activity`, body);
    const data = await res.json();

    if (data.status === 200) {
      dispatch({ type: ADD_ACTIVITY_DATA, payload: data.data });
      return data.message;
    } else {
      throw new Error(data.message);
    }
  } catch (err) {
    throw new Error(err.message);
  }
};

export const deleteActivityData = (id) => async (dispatch) => {
  try {
    const res = await fetchData("POST", `${hostUrl}/remove-activity`, { id });
    const data = await res.json();

    if (data.status === 200) {
      dispatch({ type: DELETE_ACTIVITY_DATA, payload: id });
      return data;
    } else {
      throw new Error(data.message);
    }
  } catch (err) {
    throw new Error(err.message);
  }
};
